<template>
  <div class="vehiculosCompatibles">
    <table class="table table-warning table-bordered">
      <thead>
      <tr>
        <th>#</th>
        <th>MARCA</th>
        <th>MODELO</th>
        <th>VEHICULO</th>
        <th>ES PRIMARIO</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in vehiculos">
        <td>{{index + 1}}</td>
        <td>
          <MarcaVehiculo :index="index" :marcas="marcasVehiculos" :id="'marca'+index"/>
        </td>
        <td>
          <ModeloVehiculo :index="index" :modelos="item.modelos" :id="'modelo'+index"/>
        </td>
        <td>
          <Vehiculo :index="index" :vehiculos="item.vehiculos" :id="'vehiculos'+index"/>
        </td>
        <td>
          <EsPrimario :lineaId="item.id" :index="index"/>
        </td>
        <td><i class="fa fa-close" @click="eliminarLinea(index)"></i></td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-warning btn-micro" type="button" @click="agregar">Agregar Vehiculo</button>
  </div>
</template>

<script>
  import MarcaVehiculo from "./MarcaVehiculo";
  import {mapGetters} from "vuex";
  import ModeloVehiculo from "./ModeloVehiculo";
  import Vehiculo from "./Vehiculo";
  import EsPrimario from "./EsPrimario";
  import {uuid} from "vue-uuid";

  export default {
    name: "VehiculosCompatible",
    components: {EsPrimario, Vehiculo, ModeloVehiculo, MarcaVehiculo},
    created() {
      this.getVehiculo()
    },
    computed: {
      ...mapGetters({
        marcasVehiculos: "producto/marcas"
      }),
      vehiculos: {
        get() {
          return this.$store.state.producto.producto.vehiculosCompatibles
        }
      }
    },
    methods: {
      eliminarLinea(index) {
        this.$store.commit("producto/ELIMINAR_PRODUCTO_VEHICULO_COMPATIBLE", index)
        const radios = document.querySelectorAll(".radio")
        const radio_checked = Array.from(radios).find(item => item.checked === true)
        if (radio_checked !== undefined)
          this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {key: "esPrimario", data: true, index})
      },
      agregar() {
        this.$store.commit("producto/SET_PRODUCTO_VEHICULO_COMPATIBLE", {
          id: uuid.v4(),
          marca: "",
          modelo: "",
          modelos: [],
          vehiculo: "",
          vehiculos: [],
          esPrimario: false
        })
      },
      getVehiculo() {
        if (this.$route.query.producto_id) {
          this.vehiculos.forEach((item, index) => {
            this.$store.dispatch("producto/getVehiculoCompatible", {
              index,
              vehiculo_id: item.vehiculo_id,
              esPrimario: item.vehiculo_primario
            })
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
